const IS_COLUMN = ($('.card-body').css('flex-direction') === 'column') ? true : false;
const IS_IPHONE = (navigator.userAgent.indexOf('iPhone') !== -1) ? true : false;
const key_name_id = 'rex-force-app-login-id';
const key_name_pw = 'rex-force-app-login-pw';

// iPhoneの場合、スクロールイベントを全て無効化
if (IS_IPHONE) {
    window.addEventListener('touchmove', function(event) {
        event.preventDefault();
    });
}

// ペーストイベントを追加
window.onload = function() {
	var login_id = document.getElementById('user-id'),
        login_pw = document.getElementById('password');
    login_id.addEventListener('paste', onpasteHandlerId, false);
    login_pw.addEventListener('paste', onpasteHandlerPw, false);
}

$(function() {
    // ログインID・PWをCookieから取得
    getLoginId();
    getLoginPw();

    // スマホ向け（ソフトウェアキーボードで入力領域が隠れない為）
    $('#user-id, #password')
    .focusin(function(e) {
        $(this).css('background-color', '#FFC');
        if (IS_COLUMN) {
            if (IS_IPHONE) {
                // iOS Safari の自動スクロールへの対応
                $(window).scrollTop($(window).scrollTop());
            } else {
                $('.card').css({minHeight: 0});
            }
        }
    })
    .focusout(function(e) {
        $(this).css('background-color', '');
        if (IS_COLUMN) {
            $('.card').css({minHeight: '97vh'});
        }
    });

    // 全角文字を半角文字に置換
    $(document).on('change', '#user-id', function() {
        let str = $(this).val();
        str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace( /[^!-~]/g , "" );
        $(this).val(str);
    });

    // cookieにlogin-idを保存
    $(document).on('keyup', '#user-id', function(e) {
        setLoginId();
    });
    $(document).on('blur', '#user-id', function(e) {
        setLoginId();
    });

    // cookieにlogin-pwを保存
    $(document).on('keyup', '#password', function(e) {
        setLoginPw();
    });
    $(document).on('blur', '#password', function(e) {
        setLoginPw();
    });

    // OK click ※ input の focusout と競合する為、click ではなく mousedown でも対応
    $('#btn-login').on('click mousedown', function(e) {
        // Cookieを削除
        document.cookie = key_name_id + "=;max-age=0";
        document.cookie = key_name_pw + "=;max-age=0";
        e.preventDefault();
        const $form = $(this).closest('form');
        $(this).attr('disabled', true);
        $form.trigger('submit');
    });
});

// CookieからログインID取得
let getLoginId = () => {
    const cookies = document.cookie,
        cookies_arr = cookies.split(';');
    let key_value = '';
    for (var c of cookies_arr) {
        const c_arr = c.split('='),
            key = c_arr[0],
            val = c_arr[1];
        if (key.trim() === key_name_id) {
            key_value = val;
            break;
        }
    }
    if (key_value !== '') {
        $('#user-id').val(key_value);
        document.cookie = key_name_id + "=;max-age=0";
    }
}

// CookieからログインPw取得
let getLoginPw = () => {
    const cookies = document.cookie,
        cookies_arr = cookies.split(';');
    let key_value = '';
    for (var c of cookies_arr) {
        const c_arr = c.split('='),
            key = c_arr[0],
            val = c_arr[1];
        if (key.trim() === key_name_pw) {
            key_value = val;
            break;
        }
    }
    if (key_value !== '') {
        $('#password').val(key_value);
        document.cookie = key_name_pw + "=;max-age=0";
    }
}

// CookieへログインIDを保存
let setLoginId = () => {
    const key_value = $('#user-id').val(),
        max_age = 1 * 60 * 60;  // 1時間
    document.cookie = key_name_id + "=" + key_value + ";max-age=" + max_age;
}

// CookieへログインPWを保存
let setLoginPw = () => {
    const key_value = $('#password').val(),
        max_age = 1 * 60 * 60;  // 1時間
    document.cookie = key_name_pw + "=" + key_value + ";max-age=" + max_age;
}

// 100ミリ秒後に実行
let onpasteHandlerId = () => {
    setTimeout(function() {
        setLoginId();
    }, 100);
}

// 100ミリ秒後に実行
let onpasteHandlerPw = () => {
    setTimeout(function() {
        setLoginPw();
    }, 100);
}
